export default "__VITE_ASSET__736ba4e9__"